export class States {
  public static readonly Login = 'login';
  public static readonly Logout = 'logOut';
  public static readonly ForgottenPassword = 'forgottenPassword';
  public static readonly ResetForgottenPassword = 'resetForgottenPassword';
  public static readonly ExpiredPassword = 'expiredPassword';
  public static readonly NoCaseAccess = 'noCaseAccess';
  public static readonly SystemUnavailable = 'systemUnavailable';

  public static readonly BrokerProfile = 'brokerProfile';
  public static readonly BrokerCaseHub = 'brokerCaseHub';
  public static readonly AccessController = 'accessController';
  public static readonly Agent = 'agent';
  public static readonly AgentRegistration = 'registration';
  public static readonly AgentRegistrationDetails = 'registrationDetails';

  public static readonly CustomerHub = 'customerHub';
  public static readonly CustomerApplicationOverview = 'customerApplicationOverview';
  public static readonly CustomerApplicationNoCases = 'noCases';
  public static readonly CustomerMessaging = 'customerMessaging';
  public static readonly CustomerDocuments = 'customerDocuments';
  public static readonly CustomerFees = 'customerFees';
  public static readonly CustomerAccountTransactions = 'customerAccountTransactions';
  public static readonly CustomerCasePackagingActions = 'casePackagingActions';

  public static readonly AccountActivation = 'accountActivation';
  public static readonly EmailUpdateConfirmation = 'emailUpdateConfirmation';
  public static readonly RegistrationNotification = 'registrationNotification';

  public static readonly BrokerCaseOverview = 'caseOverview';
  public static readonly BrokerCasePackagingActions = 'casePackagingActions';
  public static readonly BrokerCaseMessaging = 'caseMessaging';
  public static readonly BrokerCaseSummary = 'caseSummary';
  public static readonly BrokerCaseDocuments = 'caseDocuments';
  public static readonly BrokerCaseRecords = 'caseRecords';
  public static readonly BrokerCaseFees = 'caseFees';

  public static readonly MakePayment = 'makePayment';

  public static readonly Application = 'application';
  public static readonly YourMortgage = 'yourMortgage';
  public static readonly Applicant = 'applicant';
  public static readonly YourOutgoings = 'yourOutgoings';
  public static readonly YourProperty = 'yourProperty';
  public static readonly Declaration = 'declaration';

  public static readonly CustomerApplication = 'customerApplication';

  public static readonly Kfi = 'kfi';
  public static readonly KfiYourMortgage = 'kfiYourMortgage';
  public static readonly KfiApplicants = 'kfiApplicants';

  public static readonly SessionClosed = 'sessionClosed';

  public static readonly PrivacyPolicy = 'privacyPolicy';
  public static readonly JunkEmails = 'junkEmails';
  public static readonly CookiesPolicy = 'cookiesPolicy';
  public static readonly BrokerHelpCenter = 'brokerHelpCenter';
  public static readonly CustomerHelpCenter = 'customerHelpCenter';

  public static readonly Switch = 'switch';
  public static readonly CustomerSwitch = 'customerSwitch';
  public static readonly SwitchProductPicker = 'productPicker';
  public static readonly SwitchSummary = 'summary';

  public static readonly DirectActivation = 'directActivation';
  public static readonly DirectProfile = 'directProfile';
  public static readonly CustomerCaseHub = 'customerCaseHub';

  public static readonly NonAdvised = 'nonAdvised';
  public static readonly Residential = 'residential';
  public static readonly BuyToLet = 'buyToLet';
  public static readonly ProductPicker = 'productPicker';
  public static readonly DirectCustomerFees = 'directCustomerFees';
  public static readonly Advised = 'advised';
  public static readonly AdvisedLandingPage = 'online';
  public static readonly EligibilityQuestions = 'eligibilityQuestions';
  public static readonly BuyToLetEligibility = 'buyToLetEligibility';
  public static readonly ResidentialEligibility = 'residentialEligibility';
  public static readonly EligibilityFailed = 'eligibilityFailed';
  public static readonly EligibilityNeedAdvice = 'eligibilityNeedAdvice';
  public static readonly ExecutionOnlyEligibility = 'executionOnlyEligibility';
  public static readonly UnregisteredFactFind = 'factFind';

  public static readonly Customer = 'customer';
  public static readonly ExistingCustomerRegistration = 'registration';
  public static readonly FrictionlessRegister = 'frictionlessRegister';

  public static readonly Landing = 'landing';
  public static readonly LandingResidential = 'residential';

  public static readonly OnlineOffer = 'onlineOffer';
  public static readonly CustomerOffer = 'customerOffer';
  public static readonly OfferDocuments = 'offerDocuments';
  public static readonly AuthenticateOffer = 'authenticateOffer';
  public static readonly SendOfferAccessCode = 'sendOfferAccessCode';
  public static readonly OnlineOfferSessionClosed = 'closedSession';
  public static readonly OfferUnavailable = 'offerUnavailable';
  public static readonly OfferCompleted = 'offerCompleted';

  public static readonly MiniForms = 'miniForms';
  public static readonly UnsupportedDevice = 'unsupportedDevice';
  public static readonly DeviceInfo = 'deviceInfo';
  public static readonly Redirect = 'redirect';

  public static readonly WritingBusiness = 'writingBusiness';
}
